// extracted by mini-css-extract-plugin
export default {"ac-sidemenu-item":"wkLCT9Y4C5SVPGZYVe0t","ac-sidemenu-item--active":"TnpyRLvqQa5Dni0XAilH"};